export default __webpack_public_path__ + "static/media/IBEW-logo-img.be87a745.png";